'use client';

import type { JSX } from 'react';
import * as prismicH from '@prismicio/helpers';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { Products } from '@/components';
import { SORT_BY_MAP, stringToSlug } from '@/utils';
import { EnumCustomerType, SortBySelectOption, TreezStore } from '@/types';
import { useShowByLocationSlug } from '@/hooks';

export type ProductsCarouselProps =
  SliceComponentProps<Content.ProductsCarouselSlice>;

const ProductsCarousel = ({
  slice,
}: ProductsCarouselProps): JSX.Element | null => {
  // eslint-disable-next-line no-case-declarations
  const {
    see_all_link,
    see_all_text,
    title,
    limit,
    sort_by,
    type, // filter by category
    filter_by_brand, // filter by brand
    product_group_id, // filter by group id
    filter_by_on_sale, // filter by on sale
    filter_by_store, // filter by store
    bottom_spacing,
    padding_section,
    location_slug,
    background_color,
    background_image,
    background_style_fixed_cover,
    min_heigth,
    title_color,
    see_all_text_color,
    active_control_color,
    disable_control_color,
  } = slice.primary;

  const { showContent } = useShowByLocationSlug(location_slug as string);

  if (!slice?.primary?.active || !showContent) return null;

  const carouselListTitle = prismicH.asText(title) ?? 'Products';

  const paddingSection = padding_section;

  const analyticsListName = stringToSlug(carouselListTitle);

  const selectedStore = (slice as any).selectedStore as TreezStore;
  const selectedCustomerType = (slice as any)
    .selectedCustomerType as EnumCustomerType;

  return (
    <Products
      activeControlColor={active_control_color}
      analyticsListName={analyticsListName}
      backgroundColor={background_color}
      backgroundImage={background_image}
      backgroundStyleFixed={background_style_fixed_cover}
      disableControlColor={disable_control_color}
      filterByBrand={filter_by_brand!}
      filterByCategory={type!}
      filterByGroupId={product_group_id!}
      filterByOnSale={filter_by_on_sale}
      filterByStore={filter_by_store}
      key={selectedStore?.shortName}
      limit={limit!}
      locationSlug={location_slug!}
      minHeight={min_heigth!}
      paddingSection={paddingSection}
      products={(slice as any).products}
      seeAllHref={see_all_link ?? '/'}
      seeAllTextColor={see_all_text_color}
      seeMoreText={see_all_text!}
      selectedCustomerType={selectedCustomerType}
      selectedStore={selectedStore}
      sortBy={SORT_BY_MAP?.[sort_by] as SortBySelectOption}
      spacingBottom={bottom_spacing}
      title={carouselListTitle}
      titleColor={title_color}
      totalCount={(slice as any).totalCount}
    />
  );
};

export default ProductsCarousel;
